import { render, staticRenderFns } from "./CommentAnswer.vue?vue&type=template&id=aa9172e2&scoped=true&"
import script from "./CommentAnswer.vue?vue&type=script&lang=js&"
export * from "./CommentAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa9172e2",
  null
  
)

export default component.exports